<template>
    <v-dialog v-model="dialog" ref="modal" @keydown.esc="clearFields()" persistent max-width="900px">
        <template v-slot:activator="{ on }">
            <!-- <v-btn v-if="logo" v-on="on" text small>{{company.nome}}a</v-btn> -->
            <v-badge
                    color="black"
                    icon="mdi-cog"
                    offset-x="25"
                    offset-y="15"                    
                    overlap
                >            
                <v-btn v-on="on" large text>
                    {{company.nome}}             
                    <v-avatar size="40px" item class="ml-3">
                        <v-img          
                            :src="logo" 
                        />
                    </v-avatar>    
                </v-btn>
            </v-badge>
            <div class="mx-3"></div>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Configuração do Negócio</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-card-subtitle>
                Aqui você deverá cadastrar os seus produtos para o módulo <b>{{this.selCat}}</b>
                <v-divider></v-divider>
            </v-card-subtitle>
            <v-card-text>
                <v-row class="mt-0 mb-0 pt-0">
                    <v-col cols="4" sm="4">
                        <v-text-field v-model="nome" label="Nome do Produto *" required></v-text-field>
                    </v-col>
                    <v-col cols="8" sm="8">
                        <v-textarea v-model="descricao" rows="1" :auto-grow="true" label="Descrição"></v-textarea>
                    </v-col>  
                </v-row>
                <v-row class="mt-0 mb-0 pt-0">
                    <v-col cols="2" sm="2">
                        <v-text-field  v-model="tamanho" label="Tamanho"></v-text-field >
                    </v-col>    
                    <v-col cols="2" sm="2">
                        <v-text-field v-model="valor" label="Valor" value="10.00" prefix="R$" type="number" hint="Insira o valor do produto (#,##)" step="0.01"></v-text-field>
                    </v-col> 
                    <v-col cols="6" sm="6">
                        <v-file-input v-model="prodImg" small-chips multiple accept="image/*" label="Selecione Imagens para o seu Produto"></v-file-input>
                    </v-col>                         
                    <v-col cols="2" sm="2">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">                  
                                <v-switch v-on="on" flat v-model="ativo" :label="(ativo) ? 'Disponível' : 'Indisponível'"></v-switch>
                            </template>
                            <span>Selecione se o produto estiver disponível.</span>
                        </v-tooltip>  
                    </v-col>                             
                </v-row>
                <small>* Campos Obrigatórios</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="clearFields()">Fechar</v-btn>
                <v-btn color="blue darken-1" :loading="loading" text @click="addProducts()">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
// import {
//     db
// } from '../../main'
// import dbFunctions from "@/dbFunctions"
// import store from "@/store"
import {files} from "@/main"
import store from "@/store"
export default {
    name: 'ConfigCustomer',
    data: () => ({
        dialog: false,
        loading: false,
        rules: {
            required: value => !!value || 'Campo Obrigatório.',
            min: v => v.length >= 8 || 'Min 8 characters',
            emailMatch: () => ('The email and password you entered don\'t match'),
        },
        nome: "",
        ativo: true,
        valor: '',
        tamanho: '',
        descricao: '',
        status:true,
        key: 0,
        logo: 'https://quoon-br.web.app/semfoto.gif',
        selCat: '',
        prodImg: '',
        company: [],
    }),
    async created(){
        this.company = this.$store.getters.company.data
        let ref = files.ref();
        let logo = ''
        console.log("company",this.company.logo)
        await ref.child(this.company.logo).getDownloadURL().then(function(url){
            logo = url
        })  
        this.logo = logo.toString() 
        store.dispatch("fetchCompanyLogo",this.logo)
        // console.log("logo", this.logo)
    },
    methods: {   
        clearFields(){
            this.nome = ''
            this.status = true
            this.descricao = ''
            this.tamanho = ''
            this.valor = ''
            this.dialog = false
        }, 
    },
}
</script>
